import { IconShoppingCart } from "@tabler/icons-react";
import { useCartStore } from "../../../../hooks/stores/useCartStore";
import { Button } from "../../../../components/common/button";
import type { ProductVariantDto } from "../../../../api";
import { showSuccessToast } from "../../../../utils/toasts";

interface AddToCartButtonProps {
  product: ProductVariantDto;
  quantity?: number;
  disabled?: boolean;
  size?: "sm" | "md";
  fullWidth?: boolean;
}

export function AddToCartButton({
  product,
  quantity = 1,
  disabled,
  size = "md",
  fullWidth = false,
}: AddToCartButtonProps) {
  const { addToCart } = useCartStore();

  const isOutOfStock = Number(product.supplierStock ?? 0) === 0;
  const isDisabled = disabled !== undefined ? disabled : isOutOfStock;

  const handleAddToCart = () => {
    addToCart(product, quantity);
    showSuccessToast(`${product.name || "Product"} added to cart`);
  };

  return (
    <Button
      variant="primary"
      onClick={handleAddToCart}
      disabled={isDisabled}
      size={size}
      fullWidth={fullWidth}
      leftIcon={<IconShoppingCart size={size === "sm" ? 18 : 20} />}
    >
      Add to cart
    </Button>
  );
}
